import { Component, input, output } from '@angular/core';
import { DrawerVm, RerunFeedback } from '../agent-runs.models';

@Component({
  selector: 'app-agent-run-drawer',
  templateUrl: './agent-run-drawer.component.html',
  styleUrl: './agent-run-drawer.component.scss',
})
export class AgentRunDrawerComponent {
  open = input<boolean>(false);
  vm = input<DrawerVm | null>(null);
  rerunFeedback = input<RerunFeedback | null>(null);

  closed = output<void>();
  rerunRequested = output<void>();
}
